<div class="persona-chip" *ngIf="persona">
  <div *ngIf="persona.imageUrl; else default">
    <img class="persona-chip__img" src={{persona.imageUrl}} height="20px" width="20px">
  </div>
  <ng-template #default>
    <!-- TODO: default person img -->
    <img class="persona-chip__img" src="https://mi.glm.edu.co/Images/shadow-user.jpg" height="20px" width="20px">
  </ng-template>
  <div class="persona-chip__data">
    <p class="persona-chip__data-main">{{persona.nombresApellidos}}</p>
    <p *ngIf="persona.eMail" class="persona-chip__data-minor">{{persona.eMail}}</p>
  </div>
</div>
